import React, { useState, useEffect, useRef } from "react";

import { api } from "./pureFunctions";
import "./styles/projektstatus.css";

import ProjektstatusOptionen from "./ProjektstatusOptionen";
import ProjektstatusExpo from "./ProjektstatusExpo";
import ProjektstatusEskalationen from "./ProjektstatusEskalationen";
import ProjektstatusFreigabe from "./ProjektstatusFreigabe";
import ProjektstatusStatistik from "./ProjektstatusStatistik";
import ProjektstatusNotar from "./ProjektstatusNotar";
import { header, host, statusfarben, eskalationsLevel } from "./globalVariables";
import { getStaticData, getKachelObject, calculateStufenStatus, evaluateRule } from "./pureFunctions";
import ProjektstatusOhneNotar from "./ProjektstatusOhneNotar";
import ProjektStatusPausiert from "./ProjektstatusPausiert";
import ProjektstatusOptionenSidebar from "./ProjektstatusOptionenSidebar";
import ProjektstatusGrafik from "./ProjektstatusGrafik";
import ProjektstatusAkquise from "./ProjektstatusAkquise";
import { useConfig } from "./ConfigContext";
import ProjektstatusListe from "./ProjektstatusListe";
import { useAuth } from "./AuthContext";
import ProjektstatusAbwicklungsVorbereitung from "./ProjektstatusAbwicklungsVorbereitung";
import ProjektstatusAkquiseKunden from "./ProjektstatusAkquiseKunden";

export default function Projektstatus({}) {
   const config = useConfig();
   const { user, setUser } = useAuth();
   const [thisMonth, setThisMonth] = useState(() => {
      let heute = new Date();
      heute.setDate(1);
      return heute;
   });
   const [nextMonth, setNextMonth] = useState(() => {
      let heute = new Date();
      let newMonth = new Date(heute.getFullYear(), heute.getMonth() + 2, 0);
      return newMonth;
   });
   const [selectedEstates, setSelectedEstates] = useState();
   const [loading, setLoading] = useState(false);
   const [userListImmoPilot, setUserListImmoPilot] = useState();
   const [notarTermine, setNotarTermine] = useState();
   const [notarTermine2, setNotarTermine2] = useState();
   const [notarTermine3, setNotarTermine3] = useState();
   const [objectAbwicklungen, setObjectAbwicklungen] = useState();
   const [abwicklungOhneTermin, setAbwicklungOhneTermin] = useState();
   const [abwicklungsVorbereitung, setAbwicklungsVorbereitung] = useState();
   const [abwicklungen, setAbwicklungen] = useState();
   const [bewertungen, setBewertungen] = useState();
   const [vorlaufen, setVorlaufen] = useState();
   const [objectData, setObjectData] = useState({});
   const [verkaufen, setVerkaufen] = useState();
   const [undefiniert, setUndefiniert] = useState();
   const [einkaufstermine, setEinkaufstermine] = useState([]);
   const [allNotartermine, setAllNotartermine] = useState(() => {
      let oldData = localStorage.getItem("psStatistik");
      return oldData ? JSON.parse(oldData) : [];
   });
   const [userObjects, setUserObjects] = useState();
   const [stufenOptionen, setStufenOptionen] = useState(() => {
      const oldOptions = localStorage.getItem("pStatOpt");
      return oldOptions ? JSON.parse(oldOptions) : {};
   });

   const [benutzerOptionen, setBenutzerOptionen] = useState(() => {
      const oldOptions = localStorage.getItem("pUserOpt");
      return oldOptions ? JSON.parse(oldOptions) : {};
   });
   const [kacheln, setKacheln] = useState();

   function parseResponse(resp_data, newKachelObject) {
      return resp_data.data.map((item) => {
         const eskalationsDatum = item.elements[config.estate.eskalationsdaten]
            ? JSON.parse(item.elements[config.estate.eskalationsdaten])
            : "";
         const eskalationsDaten = structuredClone(eskalationsDatum);
         let newProjektstufenStatus = item.elements[config.estate.projektstatus]
            ? JSON.parse(item.elements[config.estate.projektstatus])
            : "";
         const newKachelStatus = item.elements[config.estate.kachelstatus]
            ? JSON.parse(item.elements[config.estate.kachelstatus])
            : "";

         if (eskalationsDatum) {
            Object.keys(eskalationsDatum).forEach((dat_item) => {
               if (new Date() < new Date(eskalationsDatum[dat_item])) {
                  delete eskalationsDatum[dat_item];
               } else {
                  if (newKachelStatus[dat_item] < eskalationsLevel) {
                     if (newKachelObject[dat_item] && newKachelObject[dat_item].stufenId)
                        newProjektstufenStatus[newKachelObject[dat_item].stufenId] = -1;
                  }
               }
            });
         }

         return {
            expovorhanden:
               item.elements[config.estate.expoVorhanden] && item.elements[config.estate.expoVorhanden] === "1"
                  ? true
                  : false,
            fototermin: item.elements[config.estate.fototermin]
               ? new Date(item.elements[config.estate.fototermin])
               : "",
            expoversandt: item.elements[config.estate.expoVersandt]
               ? new Date(item.elements[config.estate.expoVersandt])
               : "",
            vorankundigung: item.elements[config.estate.vorankundigungsdatum]
               ? new Date(item.elements[config.estate.vorankundigungsdatum])
               : "",
            vollmachtsdatum: item.elements[config.estate.vollmachtsDatumZeit]
               ? new Date(item.elements[config.estate.vollmachtsDatumZeit])
               : "",
            fotoTerminAb: item.elements[config.estate.fotoTerminAb]
               ? new Date(item.elements[config.estate.fotoTerminAb])
               : "",
            besichtigungsTerminierungsDatum: item.elements[config.estate.besichtigungsTerminierungsDatum]
               ? new Date(item.elements[config.estate.besichtigungsTerminierungsDatum])
               : "",
            benutzer: item.elements.benutzer,
            statusdatum_pausiert: item.elements[config.estate.statusdatumPausiert]
               ? item.elements[config.estate.statusdatumPausiert]
               : "",
            [config.estate.verkaufsStatus]: item.elements[config.estate.verkaufsStatus]
               ? item.elements[config.estate.verkaufsStatus]
               : "",
            id: item.id,
            eskalationspause: item.elements[config.estate.eskalationspause]
               ? {
                    text: JSON.parse(item.elements[config.estate.eskalationspause]).text,
                    datum: new Date(JSON.parse(item.elements[config.estate.eskalationspause]).datum),
                 }
               : "",
            objektbezeichnung: item.elements[config.estate.objektBezeichnung],
            objektnr_extern: item.elements.objektnr_extern,
            projektstufenstatus: newProjektstufenStatus,
            kachelstatus: newKachelStatus,
            pmfreigabe: item.elements[config.estate.pmfreigabe]
               ? JSON.parse(item.elements[config.estate.pmfreigabe])
               : "",
            eskalationen: eskalationsDatum,
            eskalationsDaten: eskalationsDaten,
            projektstufenEskalation: "",
            abwicklungsdatum:
               item.elements[config.estateSonstige.abwicklungsdatum] &&
               item.elements[config.estateSonstige.abwicklungsdatum] != "0000-00-00"
                  ? new Date(item.elements[config.estateSonstige.abwicklungsdatum])
                  : "",
            abwicklungsVorbereitungsdatum:
               item.elements[config.estateSonstige.abwicklungsVorbereitungsdatum] &&
               item.elements[config.estateSonstige.abwicklungsVorbereitungsdatum] != "0000-00-00"
                  ? new Date(item.elements[config.estateSonstige.abwicklungsVorbereitungsdatum])
                  : "",
         };
      });
   }

   function setOOFilter(mystatus, myliste) {
      if (myliste.length) {
         return {
            [config.estate.verkaufsStatus]: [{ op: "IN", val: [...mystatus] }],
            benutzer: [{ op: "IN", val: myliste }],
         };
      } else {
         return {
            [config.estate.verkaufsStatus]: [{ op: "IN", val: [...mystatus] }],
         };
      }
   }

   async function getEinkaufstermine() {
      let timeLimit = {};
      let datespan = false;
      let termine = [];
      const jetzt = new Date();

      const nextMonth = new Date();
      let startmonth = 1;

      let localEkData = false; // localStorage.getItem("psEKStatistik");
      let localEkDatum = false; //localStorage.getItem("psEKDatum");
      let oldEkData;
      if (localEkData) {
         oldEkData = JSON.parse(localEkData);

         if (new Date(JSON.parse(localEkDatum)).getMonth() < new Date().getMonth()) {
            datespan = "full";
         } else {
            termine = oldEkData.filter((item) => new Date(item.datum) < jetzt);
            // console.log(termine);
         }
      } else {
         datespan = "full";
      }

      if (datespan === "full") {
         startmonth = 1;
      } else {
         startmonth = new Date().getMonth() + 1;
      }

      setEinkaufstermine(termine);

      let terminResponse;
      jetzt.setDate(1);
      // jetzt.setFullYear(2025); // Für manuelle werte aus vergangenen Jahren

      for (let i = startmonth; i <= 12; i++) {
         nextMonth.setMonth(i);
         nextMonth.setDate(0);

         timeLimit["first"] = jetzt.getFullYear() + "-" + i.toString().padStart(2, "0") + "-01";
         timeLimit["last"] = jetzt.getFullYear() + "-" + i.toString().padStart(2, "0") + "-" + nextMonth.getDate();

         await api
            .post("/api/readProjectEinkaufstermine", timeLimit, header)
            .then((resp_data) => {
               terminResponse = resp_data.data
                  ? resp_data.data.map((item) => ({
                       datum: new Date(item.elements.date.start),
                       benutzer: item.elements.users ? item.elements.users : [],
                    }))
                  : [];

               setEinkaufstermine((prev) => [...prev, ...terminResponse]);
               termine.push(...terminResponse);
            })
            .catch((err) => {
               console.log("readProjectEinkaufstermine");

               console.log(err);
            });
      }
      console.log(termine);

      jetzt.setDate(0);
      localStorage.setItem("psEKStatistik", JSON.stringify(termine.filter((item) => new Date(item.datum) < jetzt)));
      localStorage.setItem("psEKDatum", JSON.stringify(new Date()));

      // setEinkaufstermine(termine);
   }

   async function getNotarTermine(datespan) {
      let notarLimit = {};
      const jetzt = new Date();
      jetzt.setDate(1);
      const nextMonth = new Date();

      nextMonth.setFullYear(jetzt.getMonth() + 2);

      notarLimit["first"] = jetzt.getFullYear() + "-" + (jetzt.getMonth() + 1).toString().padStart(2, "0") + "-01";
      // "2025-07-01";

      notarLimit["last"] = jetzt.getFullYear() + 1 + "-" + (jetzt.getMonth() + 1).toString().padStart(2, "0") + "-01";
      // nextMonth.getFullYear() + "-" + (nextMonth.getMonth() + 5).toString().padStart(2, "0") + "-01";

      await api.post("/api/readProjectNotartermine", notarLimit, header).then((resp_data) => {
         const monatsAnfang = new Date();
         const monatsEnde = new Date(monatsAnfang.getFullYear(), monatsAnfang.getMonth() + 1, 0);
         monatsEnde.setHours(23, 59, 59);

         const nextMonatsEnde = new Date(monatsAnfang.getFullYear(), monatsAnfang.getMonth() + 2, 0);
         nextMonatsEnde.setHours(23, 59, 59);
         monatsAnfang.setDate(1);
         monatsAnfang.setHours(0, 0, 0);

         const yearAnfang = new Date();
         yearAnfang.setMonth(0, 0);
         yearAnfang.setHours(0, 0, 0, 0);

         console.log(resp_data.data.termine);
         /* .filter(
               (item) => !(["16:00 Serientermin Notar Frey Biberach", "16:00 Notartermin Notar Frey Biberach"].includes(item.elements.subject)), //ist ein vorgemerkter Serientermin im oO
            ) */
         const newNotarTermine = resp_data.data.termine
            .filter((item) => !item.elements.isRecurrent)
            .map((item) => ({
               type: item.elements.type,
               datum: new Date(item.elements.date.start),
               ort: item.elements.location ? item.elements.location.value : "",
               benutzer: item.elements.users ? item.elements.users : [],
               subject: item.elements.subject,
               id: item.elements.estate ? item.elements.estate.id : "",
            }));
         console.log(resp_data.data);

         const newAbwicklungsobjekte = resp_data.data.objekte.reduce((oldObj, item) => {
            let innenProv = parseFloat(item.elements.innen_courtage.slice(0, -2).replace(",", "."));
            let aussenProv = parseFloat(item.elements.aussen_courtage.slice(0, -2).replace(",", "."));
            let pausInnen = parseFloat(item.elements[config.estate.provPausAK]);
            let pausAussen = parseFloat(item.elements[config.estate.provPausVK]);
            return {
               ...oldObj,
               [item.id]: {
                  notartermindatum: item.elements[config.estate.notarTerminDatum],
                  objektnr_extern: item.elements.objektnr_extern,
                  benutzer: item.elements.benutzer,
                  objektbezeichnung: item.elements[config.estate.objektBezeichnung],
                  verkauft_fur: item.elements[config.estate.verkauftFur],
                  innen_courtage: innenProv,
                  aussen_courtage: aussenProv,
                  pauschal_innenprov: pausInnen, //pauschalinnenprov inkl. mwst
                  pauschal_aussenprov: pausAussen, //pauschalaussenprov inkl mwst
                  umsatz:
                     (pausInnen
                        ? pausInnen + pausAussen
                        : 0.01 * (innenProv + aussenProv) * item.elements[config.estate.verkauftFur]) / 1.19,
               },
            };
         }, {});
         console.log(newAbwicklungsobjekte);

         setObjectAbwicklungen(newAbwicklungsobjekte);

         if (datespan === "current" && allNotartermine.length) {
            const oldNotartermine = allNotartermine.filter(
               (item) => yearAnfang < new Date(item.datum) && new Date(item.datum) < monatsAnfang,
            );

            setAllNotartermine([...oldNotartermine, ...newNotarTermine]);
            localStorage.setItem("psStatistik", JSON.stringify([...oldNotartermine, ...newNotarTermine]));
         } else {
            setAllNotartermine(newNotarTermine);
            localStorage.setItem("psStatistik", JSON.stringify(newNotarTermine));
         }
         setNotarTermine(newNotarTermine.filter((item) => item.datum < monatsEnde && item.datum > monatsAnfang));
         setNotarTermine2(newNotarTermine.filter((item) => item.datum > monatsEnde && item.datum < nextMonatsEnde));
         setNotarTermine3(newNotarTermine.filter((item) => item.datum > nextMonatsEnde));
      });
   }

   useEffect(() => {
      if (abwicklungen && allNotartermine) {
         const newNotarterminObjekte = allNotartermine.reduce((oldObj, item) => ({ ...oldObj, [item.id]: true }), {});
         if (newNotarterminObjekte[""]) {
            delete newNotarterminObjekte[""];
         }
         const newAbwicklungohneTermin = abwicklungen.filter(
            (item) => !newNotarterminObjekte[item.id] && item.projektstufenstatus.abwicklungsvorbereitung === 4,
         );
         console.log(abwicklungen);

         setAbwicklungOhneTermin(newAbwicklungohneTermin);
      }
   }, [abwicklungen, allNotartermine]);

   async function getData() {
      const benutzerOptionenList = Object.keys(benutzerOptionen);

      let [newestatekacheln, cleanUserData, newfieldConfiguration] = await getStaticData();

      setUserObjects(cleanUserData.userObject);

      const newKachelObject = getKachelObject(newestatekacheln);
      console.log(benutzerOptionenList);

      setKacheln(newKachelObject);

      api.get("/api/ip/getImmopilotUsers")
         .then((data) => {
            console.log(data.data);
            setUserListImmoPilot(data.data);
         })
         .catch((err) => {
            console.error(err);
         });

      await api
         .post(
            "/api/readProjectEskalationen",
            { filter: setOOFilter([config.select.statusUndefiniert], benutzerOptionenList) },
            header,
         )
         .then((resp_data) => {
            console.log("Undefiniert Antwort");
            console.log(resp_data);
            setUndefiniert(parseResponse(resp_data, newKachelObject));
         })
         .catch((err) => {
            console.log(err);
            // console.log(resp_data);
         });

      !stufenOptionen["Im Verkauf"] &&
         (await api
            .post(
               "/api/readProjectEskalationen",
               {
                  filter: setOOFilter(
                     [config.select.statusAktiv, config.select.statusPausiertAktiv],
                     benutzerOptionenList,
                  ),
                  data: [
                     config.estate.fototermin,
                     config.estate.verkaufsStatus,
                     config.estate.statusdatumPausiert,
                     config.estate.fotoTerminAb,
                     config.estate.besichtigungsTerminierungsDatum,
                  ],
               },
               header,
            )
            .then((resp_data) => {
               console.log("Im Verkauf Antwort");
               console.log(resp_data);

               setVerkaufen(parseResponse(resp_data, newKachelObject));
            })
            .catch((err) => {
               console.error(err);
               // console.log(resp_data);
            }));

      !stufenOptionen["In Abwicklung"] &&
         (await api
            .post(
               "/api/readProjectEskalationen",
               {
                  filter: setOOFilter(
                     [config.select.statusAbwicklung, config.select.statusAbwicklungsVorbereitung],
                     benutzerOptionenList,
                  ),
               },
               header,
            )
            .then((resp_data) => {
               console.log("In Abwicklung Antwort");
               console.log(resp_data);
               let parsedResponse = parseResponse(resp_data, newKachelObject);
               setAbwicklungen(parsedResponse);

               console.log(
                  parsedResponse.filter((item) => item.status2 === config.select.statusAbwicklungsVorbereitung),
               );

               setAbwicklungsVorbereitung(
                  parsedResponse.filter(
                     (item) =>
                        item.status2 === config.select.statusAbwicklungsVorbereitung ||
                        item.projektstufenstatus.abwicklungsvorbereitung !== 4,
                  ),
               );
            })
            .catch((err) => {
               console.error(err);
               // console.log(resp_data);
            }));

      if (!stufenOptionen["In Vorlauf"]) {
         let alleVorlaufen = [];

         alleVorlaufen.push(
            ...(await getObjectsByStatus(
               config.select.statusVorlaufOnline,
               [
                  config.estate.expoVersandt, //Expo versandt
                  config.estate.expoVorhanden, //Expo erstellt
                  config.estate.fototermin,
                  config.estate.vollmachtsDatumZeit,
                  config.estate.eskalationspause,
                  config.estate.vorankundigungsdatum,
                  config.estate.fotoTerminAb,
                  config.estate.besichtigungsTerminierungsDatum,
               ],
               benutzerOptionenList,
               newKachelObject,
            )),
         );
         alleVorlaufen.push(
            ...(await getObjectsByStatus(
               config.select.statusVorlaufOffline,
               [
                  config.estate.expoVersandt, //Expo versandt
                  config.estate.expoVorhanden, //Expo erstellt
                  config.estate.fototermin,
                  config.estate.vollmachtsDatumZeit,
                  config.estate.eskalationspause,
                  config.estate.vorankundigungsdatum,
                  config.estate.fotoTerminAb,
                  config.estate.besichtigungsTerminierungsDatum,
               ],
               benutzerOptionenList,
               newKachelObject,
            )),
         );
         console.log(alleVorlaufen);

         setVorlaufen(alleVorlaufen);
      }

      !stufenOptionen["In Vorlauf"] &&
         false &&
         (await api
            .post(
               "/api/readProjectEskalationen",
               {
                  filter: setOOFilter(
                     [config.select.statusVorlaufOnline, config.select.statusVorlaufOffline],
                     benutzerOptionenList,
                  ),
                  data: [
                     config.estate.expoVersandt, //Expo versandt
                     config.estate.expoVorhanden, //Expo erstellt
                     config.estate.fototermin,
                     config.estate.vollmachtsDatumZeit,
                     config.estate.eskalationspause,
                     config.estate.vorankundigungsdatum,
                     config.estate.fotoTerminAb,
                     config.estate.besichtigungsTerminierungsDatum,
                  ],
               },
               header,
            )
            .then((resp_data) => {
               console.log("In Vorlauf Antwort");
               console.log(resp_data.data);
               setVorlaufen(parseResponse(resp_data, newKachelObject));
            })
            .catch((err) => {
               console.error(err);
               console.log(resp_data);
            }));

      //  In Bewertungen: in_akquise
      !stufenOptionen["In Bewertung"] &&
         (await api
            .post(
               "/api/readProjectEskalationen",
               {
                  filter: setOOFilter(["in_akquise"], benutzerOptionenList),
               },
               header,
            )
            .then((resp_data) => {
               console.log("In Bewertung Antwort");
               console.log(resp_data.data);

               let parsedBewertungen = parseResponse(resp_data, newKachelObject);
               console.log(parsedBewertungen);

               setBewertungen(parsedBewertungen);
            })
            .catch((err) => {
               console.error(err);
               console.log(resp_data);
            }));

      !stufenOptionen["Notartermine"] && (await getNotarTermine("current"));
      !stufenOptionen["Einkaufstermine"] && (await getEinkaufstermine("current"));
   }

   async function getObjectsByStatus(myStatus, requestData, benutzerOptionenList, newKachelObject) {
      return await api
         .post(
            "/api/readProjectEskalationen",
            {
               filter: setOOFilter([myStatus], benutzerOptionenList),
               data: requestData,
            },
            header,
         )
         .then((resp_data) => {
            console.log(myStatus + " Antwort");
            console.log(resp_data.data);
            setObjectData((prev) => ({ ...prev, [myStatus]: parseResponse(resp_data, newKachelObject) }));
            console.log(objectData);

            return parseResponse(resp_data, newKachelObject);
         })
         .catch((err) => {
            console.error(err);
            // console.log(resp_data);
         });
   }

   useEffect(() => {
      setLoading(true);
      getData();

      setLoading(false);
   }, []);

   function updateStufenOptionen(params) {
      let newOptions = structuredClone(stufenOptionen);
      newOptions[params.key] = params.value;
      setStufenOptionen(newOptions);
      localStorage.setItem("pStatOpt", JSON.stringify(newOptions));
   }

   return (
      <>
         <title>Statusübersicht</title>
         <ProjektstatusOptionen
            initOptionen={config.projektstatusBereiche}
            stufenOptionen={stufenOptionen}
            userObjects={userObjects}
            setStufenOptionen={setStufenOptionen}
            benutzerOptionen={benutzerOptionen}
            setBenutzerOptionen={setBenutzerOptionen}
            getData={getData}
         />
         <ProjektstatusOptionenSidebar stufenOptionen={stufenOptionen} setStufenOptionen={setStufenOptionen} />
         <div className="projektstatus">
            {!stufenOptionen["Fotografie"] && kacheln && vorlaufen && verkaufen && (
               <div className="projektstatus-l1" style={{ maxWidth: "1200px" }}>
                  <ProjektstatusListe
                     spalten={config.psFotografie}
                     kacheln={kacheln}
                     heading={"Fotografie"}
                     userObjects={userObjects}
                     abschnittsarray={[...vorlaufen, ...verkaufen].filter((item) => {
                        // console.log(item);

                        return (
                           (typeof item.projektstufenstatus.fotografie !== "undefined" &&
                              item.projektstufenstatus.fotografie < 4) ||
                           (typeof item.kachelstatus.wohnflBerechnungErg !== "undefined" &&
                              item.kachelstatus.wohnflBerechnungErg !== null &&
                              item.kachelstatus.wohnflBerechnungErg < 4)
                        );
                     })}
                     showStatusStufen={true}
                     updateStufenOptionen={updateStufenOptionen}
                     topic={"Fotografie"}
                  />
               </div>
            )}
            {!stufenOptionen["Expo"] && kacheln && (
               <div className="projektstatus-l1" style={{ maxWidth: "1200px" }}>
                  <ProjektstatusExpo
                     kacheln={kacheln}
                     heading={"Exposé"}
                     userObjects={userObjects}
                     abschnittsarray={vorlaufen}
                     showStatusStufen={true}
                     updateStufenOptionen={updateStufenOptionen}
                     topic={"Expo"}
                  />
               </div>
            )}

            <div className="projektstatus-l1" style={{ maxWidth: "1200px" }}>
               {/* {!stufenOptionen["Expo-Kontrolle"] && kacheln && (
                  <ProjektstatusGrafik
                     kacheln={kacheln}
                     heading={"Expo-Kontrolle"}
                     userObjects={userObjects}
                     abschnittsarray={
                        verkaufen &&
                        verkaufen.filter(
                           (item) =>
                              item.eskalationen.expo_kontrolle &&
                              new Date(item.eskalationen.expo_kontrolle) < new Date() &&
                              item.kachelstatus.expo_kontrolle < 2,
                        )
                     }
                     showStatusStufen={true}
                     updateStufenOptionen={updateStufenOptionen}
                     topic={"Expo-Kontrolle"}
                  />
               )} */}
               {!stufenOptionen["Expo-Kontrolle"] && kacheln && (
                  /* <ProjektstatusListe
                     spalten={config.psAdmin}
                     kacheln={kacheln}
                     heading={"Admin"}
                     userObjects={userObjects}
                     abschnittsarray={[...vorlaufen, ...verkaufen].filter(
                        (item) =>
                           item.kachelstatus &&
                           typeof item.kachelstatus.wohnflBerechnungKoord !== undefined &&
                           item.kachelstatus.wohnflBerechnungKoord < 4 &&
                           item.kachelstatus.wohnflBerechnungKoord !== null,
                     )}
                     showStatusStufen={true}
                     updateStufenOptionen={updateStufenOptionen}
                     topic={"Admin"}
                  /> */
                  <ProjektstatusGrafik
                     kacheln={kacheln}
                     heading={"Expo-Kontrolle"}
                     userObjects={userObjects}
                     abschnittsarray={
                        verkaufen &&
                        verkaufen.filter(
                           (item) =>
                              item.eskalationen.expo_kontrolle &&
                              new Date(item.eskalationen.expo_kontrolle) < new Date() &&
                              item.kachelstatus.expo_kontrolle < 2,
                        )
                     }
                     showStatusStufen={true}
                     updateStufenOptionen={updateStufenOptionen}
                     topic={"Expo-Kontrolle"}
                  />
               )}
               {!stufenOptionen["Akquiseprüfung"] && kacheln && (
                  <ProjektstatusAkquise
                     kacheln={kacheln}
                     heading={"Akquiseprüfung"}
                     userObjects={userObjects}
                     abschnittsarray={
                        bewertungen &&
                        bewertungen.filter(
                           (item) =>
                              item.kachelstatus &&
                              item.kachelstatus.bewertungsergebnisAbsagesprüfung &&
                              item.kachelstatus.bewertungsergebnisAbsagesprüfung !== 0 &&
                              item.kachelstatus.bewertungsergebnisAbsagesprüfung < 4,
                        )
                     }
                     showStatusStufen={true}
                     updateStufenOptionen={updateStufenOptionen}
                     topic={"Akquiseprüfung"}
                  />
               )}
               {!stufenOptionen["Admin"] && kacheln && vorlaufen && verkaufen && (
                  <ProjektstatusListe
                     spalten={config.psAdmin}
                     kacheln={kacheln}
                     heading={"Admin"}
                     userObjects={userObjects}
                     abschnittsarray={[...vorlaufen, ...verkaufen, ...abwicklungen].filter(
                        (item) =>
                           item.kachelstatus &&
                           typeof item.kachelstatus.wohnflBerechnungKoord !== undefined &&
                           item.kachelstatus.wohnflBerechnungKoord < 4 &&
                           item.kachelstatus.wohnflBerechnungKoord !== null,
                     )}
                     showStatusStufen={true}
                     updateStufenOptionen={updateStufenOptionen}
                     topic={"Admin"}
                  />
               )}
               {!stufenOptionen["Besichtigungstermine"] && kacheln && vorlaufen && verkaufen && (
                  <ProjektstatusListe
                     spalten={config.psBesichtigungstermine}
                     kacheln={kacheln}
                     heading={"Besichtigungszeitfenster-Anfragen"}
                     userObjects={userObjects}
                     abschnittsarray={[...vorlaufen, ...verkaufen].filter(
                        (item) =>
                           item.kachelstatus && item.kachelstatus.besichtigung && item.kachelstatus.besichtigung < 4,
                     )}
                     showStatusStufen={true}
                     updateStufenOptionen={updateStufenOptionen}
                     topic={"Besichtigungstermine"}
                  />
               )}

               {!stufenOptionen["Admin"] &&
                  kacheln &&
                  user.Name === "JonathanMischke" &&
                  vorlaufen &&
                  verkaufen &&
                  true &&
                  config.projektstatusAnzeigen &&
                  config.projektstatusAnzeigen.map((iteAnzeige) => {
                     return (
                        <ProjektstatusListe
                           spalten={iteAnzeige.spalten}
                           kacheln={kacheln}
                           heading={iteAnzeige.name}
                           userObjects={userObjects}
                           abschnittsarray={[...vorlaufen, ...verkaufen].filter((item) =>
                              evaluateRule(item, iteAnzeige.filter),
                           )}
                           showStatusStufen={true}
                           updateStufenOptionen={updateStufenOptionen}
                           topic={iteAnzeige.name}
                        />
                     );
                  })}
            </div>

            {userListImmoPilot && (
               <div className="projektstatus-l1" style={{ maxWidth: "400px" }}>
                  <ProjektstatusAkquiseKunden
                     data={userListImmoPilot}
                     heading={"AkquiseKunden"}
                     userObjects={userObjects}
                  />
               </div>
            )}

            {/* {!stufenOptionen["Akquiseprüfung"] && kacheln && (
               <div className="projektstatus-l1" style={{ maxWidth: "800px" }}>
                  <ProjektstatusAkquise
                     kacheln={kacheln}
                     heading={"Akquiseprüfung"}
                     userObjects={userObjects}
                     abschnittsarray={
                        bewertungen &&
                        bewertungen.filter(
                           (item) =>
                              item.kachelstatus &&
                              item.kachelstatus.bewertungsergebnisAbsagesprüfung &&
                              item.kachelstatus.bewertungsergebnisAbsagesprüfung !== 0 &&
                              item.kachelstatus.bewertungsergebnisAbsagesprüfung < 4,
                        )
                     }
                     showStatusStufen={true}
                     updateStufenOptionen={updateStufenOptionen}
                     topic={"Akquiseprüfung"}
                  />
               </div>
            )} */}
            {/* {!stufenOptionen["Admin"] && kacheln && vorlaufen && verkaufen && (
               <div className="projektstatus-l1" style={{ maxWidth: "800px" }}>
                  <ProjektstatusListe
                     spalten={config.psAdmin}
                     kacheln={kacheln}
                     heading={"Admin"}
                     userObjects={userObjects}
                     abschnittsarray={[...vorlaufen, ...verkaufen].filter(
                        (item) =>
                           item.kachelstatus &&
                           typeof item.kachelstatus.wohnflBerechnungKoord !== undefined &&
                           item.kachelstatus.wohnflBerechnungKoord < 4 &&
                           item.kachelstatus.wohnflBerechnungKoord !== null,
                     )}
                     showStatusStufen={true}
                     updateStufenOptionen={updateStufenOptionen}
                     topic={"Admin"}
                  />
               </div>
            )} */}

            <div className="projektstatus-l1 projektstatus-eskalationen pt-0" style={{ maxWidth: "1600px" }}>
               {undefiniert && (
                  <div className="projektstatus-l2 text-center">
                     <h2 className="eskalations-heading">
                        <span>{undefiniert.length}</span>
                        Undefiniert
                     </h2>
                     {undefiniert.map((item) => {
                        return (
                           <a
                              style={{ color: "#ddf", margin: "0 4px" }}
                              href={"/datenblatt?estateid=" + item.id}
                              target="_blank"
                           >
                              {" "}
                              {item.objektnr_extern}
                           </a>
                        );
                     })}
                  </div>
               )}
               <div className="flex-row-parent">
                  {/* <div className="projektstatus-l2">
                     <h2 className="eskalations-heading">
                        {userListImmoPilot && (
                           <span>
                              {" "}
                              {userListImmoPilot.map((item) => Object.values(item.notifications ?? {}).flat()).flat().length}
                           </span>
                        )}
                        <br />
                        Akquisekunden
                     </h2>
                  </div> */}
                  <div className="projektstatus-l2">
                     <h2 className="eskalations-heading">
                        {bewertungen && <span> {bewertungen.length}</span>}
                        <br />
                        In Bewertung
                     </h2>
                  </div>
                  <div className="projektstatus-l2">
                     <h2 className="eskalations-heading">
                        {vorlaufen && <span>{vorlaufen.length}</span>}
                        <br />
                        In Vorlauf
                     </h2>
                  </div>
                  <div className="projektstatus-l2">
                     <h2 className="eskalations-heading">
                        {verkaufen && (
                           <span>
                              {
                                 verkaufen.filter(
                                    (item) => item[config.estate.verkaufsStatus] === config.select.statusAktiv,
                                 ).length
                              }
                           </span>
                        )}
                        {verkaufen && (
                           <button
                              onClick={() =>
                                 setSelectedEstates({
                                    heading: "Pausiert",
                                    estates: verkaufen.filter(
                                       (item) =>
                                          item[config.estate.verkaufsStatus] === config.select.statusPausiertAktiv,
                                    ),
                                 })
                              }
                              className="clean-button"
                              title="davon pausiert"
                              style={{
                                 position: "absolute",
                                 marginTop: "10px",
                                 fontSize: "26px",
                                 color: "#fff",
                                 cursor: "pointer",
                              }}
                           >
                              +
                              {
                                 verkaufen.filter(
                                    (item) => item[config.estate.verkaufsStatus] === config.select.statusPausiertAktiv,
                                 ).length
                              }
                           </button>
                        )}
                        <ProjektStatusPausiert
                           selectedEstates={selectedEstates}
                           setSelectedEstates={setSelectedEstates}
                        />
                        <br />
                        Im Verkauf
                     </h2>
                  </div>
                  <div className="projektstatus-l2">
                     <h2 className="eskalations-heading">
                        {abwicklungen && <span>{abwicklungen.length}</span>}
                        <br />
                        In Abwicklung
                     </h2>
                  </div>
               </div>

               <div className="flex-row-parent">
                  {!stufenOptionen["In Bewertung"] && kacheln && (
                     <ProjektstatusEskalationen
                        kacheln={kacheln}
                        heading={""}
                        userObjects={userObjects}
                        abschnittsarray={bewertungen}
                        showStatusStufen={false}
                     />
                  )}

                  {!stufenOptionen["In Vorlauf"] && kacheln && (
                     <ProjektstatusEskalationen
                        kacheln={kacheln}
                        heading={""}
                        userObjects={userObjects}
                        abschnittsarray={vorlaufen}
                        showStatusStufen={false}
                        statusLevel={"In Vorlauf"}
                     />
                  )}
                  {!stufenOptionen["Im Verkauf"] && kacheln && (
                     <ProjektstatusEskalationen
                        kacheln={kacheln}
                        heading={""}
                        userObjects={userObjects}
                        abschnittsarray={
                           verkaufen &&
                           verkaufen.filter((item) => item[config.estate.verkaufsStatus] === config.select.statusAktiv)
                        }
                        showStatusStufen={false}
                     />
                  )}

                  {!stufenOptionen["In Abwicklung"] && kacheln && (
                     <ProjektstatusEskalationen
                        kacheln={kacheln}
                        heading={""}
                        userObjects={userObjects}
                        abschnittsarray={abwicklungen}
                        showStatusStufen={false}
                     />
                  )}
               </div>

               <div className="flex-row-parent">
                  {!stufenOptionen["In Bewertung"] && kacheln && (
                     <ProjektstatusFreigabe
                        kacheln={kacheln}
                        heading={""}
                        userObjects={userObjects}
                        abschnittsarray={bewertungen}
                        showStatusStufen={false}
                        shownKachelstatus={2}
                        color={statusfarben[2]}
                     />
                  )}

                  {!stufenOptionen["In Vorlauf"] && kacheln && (
                     <ProjektstatusFreigabe
                        kacheln={kacheln}
                        heading={""}
                        userObjects={userObjects}
                        abschnittsarray={vorlaufen}
                        showStatusStufen={false}
                        shownKachelstatus={2}
                        color={statusfarben[2]}
                     />
                  )}
                  {!stufenOptionen["Im Verkauf"] && kacheln && (
                     <ProjektstatusFreigabe
                        kacheln={kacheln}
                        heading={""}
                        userObjects={userObjects}
                        abschnittsarray={
                           verkaufen &&
                           verkaufen.filter((item) => item[config.estate.verkaufsStatus] === config.select.statusAktiv)
                        }
                        showStatusStufen={false}
                        shownKachelstatus={2}
                        color={statusfarben[2]}
                     />
                  )}
                  {!stufenOptionen["In Abwicklung"] && kacheln && (
                     <ProjektstatusFreigabe
                        kacheln={kacheln}
                        heading={""}
                        userObjects={userObjects}
                        abschnittsarray={abwicklungen}
                        showStatusStufen={false}
                        shownKachelstatus={2}
                        color={statusfarben[2]}
                     />
                  )}
               </div>
               <div className="flex-row-parent">
                  {!stufenOptionen["In Bewertung"] && kacheln && (
                     <ProjektstatusFreigabe
                        kacheln={kacheln}
                        heading={""}
                        userObjects={userObjects}
                        abschnittsarray={bewertungen}
                        showStatusStufen={false}
                        shownKachelstatus={3}
                        color={statusfarben[3]}
                     />
                  )}

                  {!stufenOptionen["In Vorlauf"] && kacheln && (
                     <ProjektstatusFreigabe
                        kacheln={kacheln}
                        heading={""}
                        userObjects={userObjects}
                        abschnittsarray={vorlaufen}
                        showStatusStufen={false}
                        shownKachelstatus={3}
                        color={statusfarben[3]}
                     />
                  )}
                  {!stufenOptionen["Im Verkauf"] && kacheln && (
                     <ProjektstatusFreigabe
                        kacheln={kacheln}
                        heading={""}
                        userObjects={userObjects}
                        abschnittsarray={
                           verkaufen &&
                           verkaufen.filter((item) => item[config.estate.verkaufsStatus] === config.select.statusAktiv)
                        }
                        showStatusStufen={false}
                        shownKachelstatus={3}
                        color={statusfarben[3]}
                     />
                  )}
                  {!stufenOptionen["In Abwicklung"] && kacheln && (
                     <ProjektstatusFreigabe
                        kacheln={kacheln}
                        heading={""}
                        userObjects={userObjects}
                        abschnittsarray={abwicklungen}
                        showStatusStufen={false}
                        shownKachelstatus={3}
                        color={statusfarben[3]}
                     />
                  )}
               </div>
               <div className="flex-row-parent">
                  {!stufenOptionen["Auswertung"] && !loading && kacheln && (
                     <ProjektstatusStatistik
                        // kacheln={kacheln}
                        objectAbwicklungen={objectAbwicklungen}
                        allNotartermine={allNotartermine}
                        einkaufstermine={einkaufstermine}
                     />
                  )}
               </div>
            </div>

            {!stufenOptionen["Notartermine"] && (
               <div className="projektstatus-l1">
                  <div className="flex-row-parent" style={{ width: "fit-content", flexWrap: "wrap" }}>
                     <div className="flex-row-parent" style={{ maxWidth: "700px" }}>
                        {notarTermine && (
                           <ProjektstatusNotar
                              objekte={objectAbwicklungen}
                              month={thisMonth}
                              main={true}
                              heading={thisMonth.toLocaleString("de", { month: "long" })}
                              notarTermine={notarTermine}
                              userObjects={userObjects}
                              adminView={
                                 user.Name === "JonathanMischke" || user.Name === "ADorner" || user.Name === "FBaur"
                              }
                           />
                        )}
                     </div>
                     <div className="flex-column-parent" style={{ maxWidth: "700px" }}>
                        {notarTermine2 && (
                           <ProjektstatusNotar
                              objekte={objectAbwicklungen}
                              month={nextMonth}
                              heading={nextMonth.toLocaleString("de", { month: "long" })}
                              notarTermine={notarTermine2}
                              userObjects={userObjects}
                              adminView={
                                 user.Name === "JonathanMischke" || user.Name === "ADorner" || user.Name === "FBaur"
                              }
                           />
                        )}
                        {notarTermine3 && (
                           <ProjektstatusNotar
                              objekte={objectAbwicklungen}
                              heading={"Nach " + nextMonth.toLocaleString("de", { month: "long" })}
                              notarTermine={notarTermine3}
                              userObjects={userObjects}
                              adminView={
                                 user.Name === "JonathanMischke" || user.Name === "ADorner" || user.Name === "FBaur"
                              }
                           />
                        )}
                        {abwicklungOhneTermin && (
                           <ProjektstatusOhneNotar
                              adminView={
                                 user.Name === "JonathanMischke" || user.Name === "ADorner" || user.Name === "FBaur"
                              }
                              objekte={abwicklungOhneTermin}
                              abwicklungObjekte={objectAbwicklungen}
                              userObjects={userObjects}
                           />
                        )}
                        {abwicklungOhneTermin && (
                           <ProjektstatusAbwicklungsVorbereitung
                              adminView={
                                 user.Name === "JonathanMischke" || user.Name === "ADorner" || user.Name === "FBaur"
                              }
                              objekte={abwicklungsVorbereitung}
                              userObjects={userObjects}
                           />
                        )}
                     </div>
                  </div>
               </div>
            )}
         </div>
      </>
   );
}
